import { Controller } from "@hotwired/stimulus";
import { dataTableFunctions } from "../../datatables/datatable_functions";
import $ from "jquery";

export default class extends Controller {
  static values = {
    sourceUrl: String,
    tableId: String,
    defaultParams: Object,
  };

  export() {
    const params = this._setParams();
    const queryStringParams = this._converParamsToQueryString(params);
    const url = `${this.sourceUrlValue}?${queryStringParams}`;

    window.location.href = url;
  }

  _setParams() {
    let params = dataTableFunctions().retrieveDatatableParams(this.tableIdValue);
    params = dataTableFunctions().setParamsToRetrieveAllDatatableRows(params);
    params = dataTableFunctions().removeUndefinedParams(params);

    return { ...this.defaultParamsValue, ...params };
  }

  _converParamsToQueryString(params) {
    return $.param(params);
  }
}
